import axios from 'axios';
import {
  AnalyticsMeasure,
  AnalyticsFields
} from 'src/views/dashboard/DashboardView/types';

export const baseURL = `${process.env.REACT_APP_API_URL}/api/v1`;

export const axiosInstance = axios.create({ baseURL });

export const urls = {
  token: '/auth/token/',
  refreshAccess: '/auth/token/refresh/',
  passports: '/passport/',
  passportById(id: number | string): string {
    return `/passport/${id}/`;
  },
  passportVersion: 'passport/versions/',
  passportPreview: '/passport/preview/',
  passportPreviewRAO: '/passport/preview_rao/',
  passportsBatchCreate: '/passport/batch_create/',
  organizationAutocomplete: '/organization/autocomplete/',
  packageTypeAutocomplete: '/dictionaries/batch_package_type/autocomplete/',
  radionuclideAutocomplete: '/dictionaries/radionuclide/autocomplete/',
  operationDocuments: '/dictionaries/operation_document/',
  movePackageInRepository: '/repository/passport_location/move/',
  passportOperations: '/repository/operation/',
  reportRAO(
    pageSize: number,
    page: number,
    filters: string
  ): string {
    return `/report/rao/json/?page_size=${
      pageSize
    }&page=${
      page
    }${
      filters ? `&${filters}` : ''
    }`;
  },
  reportRAOXlsx(
    filters: string
  ): string {
    return `/report/rao/xlsx/?${
      filters ? `${filters}` : ''
    }`;
  },
  reportOobXlsx: '/report/oob/xlsx/',
  reportOperativeXlsx: '/report/operative/xlsx/',
  reportAnnualXlsx: '/report/annual/xlsx/',
  reportInventoryXlsx: '/report/inventory/xlsx/',
  reportTransportationXlsx: '/report/transportation/xlsx/',
  repositoryAutocomplete: '/repository/autocomplete/',
  passportDetailAutocomplete(query: string): string {
    return `/passport/detail_autocomplete/?q=${query}&status=registered`;
  },
  checkPatchedPassport: '/passport/check_errors/',
  getPassportErrorsReport: '/passport/report_errors/',
  getPassportQR(id: number | string): string {
    return `/passport/${id}/qr/`;
  },
  deliveryReports: '/act/',
  getdeliveryReportById(id: number | string): string {
    return `/act/${id}/`;
  },
  exportDeliveryReport(id: number | string): string {
    return `/act/${id}/report/`;
  },
  getRepositories: '/repository/',
  getRepositoryById(id: number | string): string {
    return `/repository/${id}/`;
  },
  getCellsInRepository(repositoryId: number | string): string {
    return `/repository/cell/?repository=${repositoryId}`;
  },
  getRowsInCell(cellId: number | string): string {
    return `/repository/row/?cell=${cellId}`;
  },
  createRowInCell: '/repository/row/',
  getRowById(rowId: number | string): string {
    return `/repository/row/${rowId}/`;
  },
  getRowScheme(rowId: number | string): string {
    return `/repository/row/${rowId}/schema/`;
  },
  placePackageInRow: '/repository/passport_location/',
  getRowContent(rowId: number | string): string {
    return `/repository/passport_location/?row=${rowId}`;
  },
  getPlacedPackageById(packageId: number | string): string {
    return `/repository/passport_location/${packageId}/`;
  },
  getPathInRepository(
    paramName: string,
    paramValue: string
  ): string {
    return `/repository/path/?${paramName}=${paramValue}`;
  },
  batchPackageTypes: '/dictionaries/batch_package_type/',
  nfmReportJSON(
    repositoryId: number | string,
    cellId?: number | string
  ): string {
    return `/report/nfm/json/?repository=${repositoryId}${cellId ? `&cell=${encodeURIComponent(cellId)}` : ''}`;
  },
  nfmReportXLSX(
    repositoryId: number | string,
    cellId?: number | string
  ): string {
    return `/report/nfm/xlsx/?repository=${repositoryId}${cellId ? `&cell=${encodeURIComponent(cellId)}` : ''}`;
  },
  filerBrowseRead: '/filer/browse/',
  filerFile(id: number | string): string {
    return `/filer/file/${id}/`;
  },
  filerFolderCreate: '/filer/folder/',
  filerFolder(id: number | string): string {
    return `/filer/folder/${id}/`;
  },
  filerFolderDownload(id: number | string): string {
    return `/filer/folder/download/?id=${id}`;
  },
  filerFileDownload(id: number | string): string {
    return `/filer/file/${id}/download/`;
  },
  filerUpload: '/filer/upload/',
  analyticsMain: '/analytics/main/',
  analytics(
    measure: AnalyticsMeasure,
    groupBy: AnalyticsFields[],
    xAxis: AnalyticsFields,
    filtersQuery: string
  ): string {
    return `/analytics/?aggregate_field=${
      measure
    }&x_field=${
      xAxis
    }${
      groupBy.reduce((acc, field) => `${acc}&group_fields=${field}`, '')
    }${
      filtersQuery ?? ''
    }`;
  },
  analyticsByContract(
    measure: AnalyticsMeasure,
    filtersQuery: string
  ): string {
    return `/analytics/by_contract/?aggregate_field=${
      measure
    }${
      filtersQuery ?? ''
    }`;
  },
  passportHistory(
    type: 'rao' | 'passport',
    pageSize: number,
    page: number,
    filters: string
  ): string {
    return `/passport/history/?type=${
      type
    }&page_size=${
      pageSize
    }&page=${
      page
    }${
      filters ? `&${filters}` : ''
    }`;
  },
  annualReportYears: '/act/years_registered/'
};
